var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{staticClass:"no-background",attrs:{"options":_vm.options,"size":"lg"},on:{"change":_vm.handleChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }